import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  score: number | undefined;
  disableBorder?: boolean;
  /** 'default' keeps the legacy card, 'panel' renders the two-zone panel design */
  variant?: 'default' | 'panel';
}

const MatchOverall: React.FC<Props> = ({ score, disableBorder, variant = 'default' }) => {
  const { classes, cx } = useStyles({ disableBorder });
  const { t } = useTranslation();

  const paiScore = !_.isNil(score) ? `${(score * 100).toFixed(0)}%` : '-';

  if (variant === 'panel') {
    return (
      <div className={classes.panelMatch}>
        <Typography className={classes.panelTitle}>{t('paiMatch')}</Typography>
        <Typography className={classes.panelScore}>{!_.isNil(score) ? `${(score * 100).toFixed(0)} %` : '-'}</Typography>
      </div>
    );
  }

  return (
    <div className={classes.match}>
      <Typography className={classes.title}>{t('paiMatch')}</Typography>
      <div className={cx(classes.scoreContainer, !_.isNil(score) ? 'has-match' : undefined)}>
        {!_.isNil(score) ? <ArrowForwardIcon className={classes.icon} /> : null}
        <Typography className={classes.score}>{paiScore}</Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles<{ disableBorder?: boolean }>()((theme, { disableBorder }) => ({
  match: {
    width: '100%',
    background: '#FFF',
    border: disableBorder ? 'unset' : `2px solid ${theme.palette.backgrounds.main}`,
    padding: '8px 16px',
  },
  title: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    textAlign: 'center',
    marginBottom: '4px',
  },
  scoreContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.has-match': {
      paddingRight: '24px',
    },
  },
  icon: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    marginRight: '8px',
  },
  score: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
  },
  panelMatch: {
    width: '100%',
    display: 'flex',
    alignItems: 'baseline',
    gap: '12px',
  },
  panelTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 500,
  },
  panelScore: {
    marginLeft: 'auto',
    fontSize: theme.typography.pxToRem(28),
    fontWeight: 500,
    lineHeight: 1.2,
  },
}));

export default MatchOverall;
